import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Badge,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// import Select from "react-select";
// import TableScrollbar from "react-table-scrollbar";

import SimpleBar from "simplebar-react";

import moment from "moment";
import {
  SetParams,
  AuditPO,
  getAuditPurchaseOrderList,
  AuditPurchaseOrderListSuccessful,
  OpenScreen,
} from "../../store/Audit_Report/actions";
import LoadingModel from "../LoadingModel";

// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

class AuditReports extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.SetParams({
      ...this.props.params,
      search: "",
      page: 1,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment().startOf("month").format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
    this.props.getAuditPurchaseOrderList({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment().startOf("month").format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
      page: 1,
    });
    // this.props.AuditPurchaseOrderListSuccessful({ count: 0, results: {} });
  }
  SearchHandle = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getAuditPurchaseOrderList({
        ...this.props.params,
        page: 1,
        search: "",
        start_date:
          this.props.params.start_date == null ||
          this.props.params.start_date === ""
            ? moment(new Date()).format("YYYY-MM-DD")
            : this.props.params.start_date,
        end_date:
          this.props.params.end_date == null ||
          this.props.params.end_date === ""
            ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
            : moment(this.props.params.end_date)
                .add(1, "days")
                .format("YYYY-MM-DD"),
      });
    }
  };

  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getAuditPurchaseOrderList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
        start_date:
          this.props.params.start_date == null ||
          this.props.params.start_date === ""
            ? moment(new Date()).format("YYYY-MM-DD")
            : this.props.params.start_date,
        end_date:
          this.props.params.end_date == null ||
          this.props.params.end_date === ""
            ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
            : moment(this.props.params.end_date)
                .add(1, "days")
                .format("YYYY-MM-DD"),
      });
    }
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getAuditPurchaseOrderList({
      ...this.props.params,
      page: pageNo,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date()).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
             {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    {/* <Link
                      to="/reports"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link> */}
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Audit Report
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-1">
                    <Row className="p-1">
                      <Col md={12}>
                        <Card className="p-1">
                          <CardBody className="pt-1">
                            <Row>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationFromDate"
                                    className="col-form-label"
                                  >
                                    From Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.start_date == null ||
                                      this.props.params.start_date === ""
                                        ? moment(new Date()).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.start_date
                                    }
                                    onChange={(e) => {
                                      this.props.SetParams({
                                        ...this.props.params,
                                        start_date: e.target.value,
                                        page: 1,
                                      });
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="start_date"
                                    placeholder="select Date"
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationToDate"
                                    className="mb-0 col-form-label"
                                  >
                                    To Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.end_date == null ||
                                      this.props.params.end_date === ""
                                        ? moment(new Date()).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.end_date
                                    }
                                    onChange={(e) => {
                                      this.props.SetParams({
                                        ...this.props.params,
                                        end_date: e.target.value,
                                        page: 1,
                                      });
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="end_date"
                                    placeholder="select Date"
                                    disabled={
                                      this.props.params.start_date === ""
                                        ? true
                                        : false
                                    }
                                    min={moment(
                                      this.props.params.start_date
                                    ).format("YYYY-MM-DD")}
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col
                                md={3}
                                className="mt-1 text-center font-size-14"
                              >
                                <div className="mb-1">
                                  <Label>&nbsp;</Label>
                                </div>
                                <Button
                                  block
                                  type="button"
                                  color="primary"
                                  className="waves-effect waves-light"
                                  onClick={() => {
                                    this.props.getAuditPurchaseOrderList({
                                      ...this.props.params,
                                      start_date:
                                        this.props.params.start_date == null ||
                                        this.props.params.start_date === ""
                                          ? moment(new Date()).format(
                                              "YYYY-MM-DD"
                                            )
                                          : this.props.params.start_date,
                                      end_date:
                                        this.props.params.end_date == null ||
                                        this.props.params.end_date === ""
                                          ? moment(new Date())
                                              .add(1, "days")
                                              .format("YYYY-MM-DD")
                                          : moment(this.props.params.end_date)
                                              .add(1, "days")
                                              .format("YYYY-MM-DD"),
                                      page: 1,
                                    });
                                  }}
                                >
                                  Get Report
                                </Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Purchase Order List
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-1">
                    <div>
                      <Row>
                        <Col md={3}>
                          <FormGroup className="m-0">
                            <InputGroup>
                              <Input
                                type="text"
                                name="search"
                                className="form-control d-inline-block"
                                placeholder="Search"
                                validate={{ required: true }}
                                onChange={(e) => {
                                  this.props.SetParams({
                                    ...this.props.params,
                                    search: e.target.value,
                                    page: 1,
                                  });
                                  this.SearchHandle(e);
                                }}
                                onKeyDown={(e) => this.handleSearch(e)}
                              />
                              <InputGroupAddon addonType="append">
                                <Button
                                  color="light"
                                  type="submit"
                                  onClick={() =>
                                    this.props.getAuditPurchaseOrderList({
                                      ...this.props.params,
                                      start_date:
                                        this.props.params.start_date == null ||
                                        this.props.params.start_date === ""
                                          ? moment(new Date()).format(
                                              "YYYY-MM-DD"
                                            )
                                          : this.props.params.start_date,
                                      end_date:
                                        this.props.params.end_date == null ||
                                        this.props.params.end_date === ""
                                          ? moment(new Date())
                                              .add(1, "days")
                                              .format("YYYY-MM-DD")
                                          : moment(this.props.params.end_date)
                                              .add(1, "days")
                                              .format("YYYY-MM-DD"),
                                      page: 1,
                                    })
                                  }
                                >
                                  <i className="ri-search-line"></i>
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                        </Col>
                        <Col md={9}>
                          <div className="float-right p-1">
                            <div className="d-inline-block">
                              <Pagination aria-label="Page navigation example">
                                <PaginationItem
                                  disabled={this.props.params.page <= 1}
                                >
                                  <PaginationLink
                                    onClick={(e) => this.openPage(1)}
                                    previous
                                    // href="#"
                                  />
                                </PaginationItem>

                                {this.props.params.page > 2 && (
                                  <PaginationItem
                                    disabled={this.props.params.page <= 2}
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page - 2
                                        )
                                      }
                                      // href="#"
                                    >
                                      {this.props.params.page - 2}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page > 1 && (
                                  <PaginationItem
                                    disabled={this.props.params.page === 1}
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page - 1
                                        )
                                      }
                                      // href="#"
                                    >
                                      {this.props.params.page - 1}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}

                                <PaginationItem active={true}>
                                  <PaginationLink
                                    onClick={() =>
                                      this.openPage(this.props.params.page)
                                    }
                                    // href="#"
                                  >
                                    {this.props.params.page}
                                  </PaginationLink>
                                </PaginationItem>
                                {this.props.params.page + 1 <=
                                  this.props.params.no_of_pages && (
                                  <PaginationItem
                                    disabled={
                                      this.props.params.page + 1 >
                                      this.props.params.no_of_pages
                                    }
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page + 1
                                        )
                                      }
                                      // href="#"
                                    >
                                      {this.props.params.page + 1}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page + 2 <=
                                  this.props.params.no_of_pages && (
                                  <PaginationItem
                                    disabled={
                                      this.props.params.page + 2 >
                                      this.props.params.no_of_pages
                                    }
                                  >
                                    <PaginationLink
                                      onClick={() =>
                                        this.openPage(
                                          this.props.params.page + 2
                                        )
                                      }
                                      // href="#"
                                    >
                                      {this.props.params.page + 2}
                                    </PaginationLink>
                                  </PaginationItem>
                                )}
                                {this.props.params.page + 3 <=
                                  this.props.params.no_of_pages &&
                                  this.props.params.page < 3 && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 3 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 3
                                          )
                                        }
                                        // href="#"
                                      >
                                        {this.props.params.page + 3}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}
                                {this.props.params.page + 4 <=
                                  this.props.params.no_of_pages &&
                                  this.props.params.page < 2 && (
                                    <PaginationItem
                                      disabled={
                                        this.props.params.page + 4 >
                                        this.props.params.no_of_pages
                                      }
                                    >
                                      <PaginationLink
                                        onClick={() =>
                                          this.openPage(
                                            this.props.params.page + 4
                                          )
                                        }
                                        // href="#"
                                      >
                                        {this.props.params.page + 4}
                                      </PaginationLink>
                                    </PaginationItem>
                                  )}

                                <PaginationItem
                                  disabled={
                                    this.props.params.no_of_pages ===
                                    this.props.params.page
                                  }
                                >
                                  <PaginationLink
                                    onClick={(e) =>
                                      this.openPage(
                                        this.props.params.no_of_pages
                                      )
                                    }
                                    next
                                    // href="#"
                                  />
                                </PaginationItem>
                              </Pagination>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <SimpleBar style={{ maxHeight: "100%" }}>
                      <Card className="p-0">
                        <CardBody className="p-2 ">
                          <div className="table-responsive m-0">
                            <Table
                              bordered
                              hover
                              className="mb-0 p-0 table-centered"
                            >
                              <thead className="bg-light text-center">
                                <tr>
                                  <th className="nowrap">Code</th>
                                  <th className="nowrap">No.of Items</th>
                                  <th className="nowrap">Quotation Date</th>
                                  <th className="nowrap">RFQ No</th>
                                  <th className="nowrap">RFQ Date</th>
                                  <th className="nowrap">Gross Value</th>
                                  <th className="nowrap">Audit Status</th>
                                </tr>
                              </thead>
                              <tbody className="nowrap">
                                {this.props.AuditPOListCount !== 0 ? (
                                  <>
                                    {this.props.AuditPOList?.map((po, key) => (
                                      <tr key={key} className="text-center">
                                        <td>
                                          <Link
                                            to="/AuditReportcard"
                                            className="m-0"
                                            // onClick={() =>
                                            //   this.props.modelListOpen(po.id)
                                            // }
                                          >
                                            <Button
                                              type="button"
                                              color="success"
                                              className="waves-effect waves-light orderlist_but m-2 p-1 mb-2"
                                              onClick={() =>
                                                this.props.AuditPO({
                                                  ScreenID: po.id,
                                                })
                                              }
                                            >
                                              <i className="mdi mdi-file-document mr-1"></i>
                                              {po.code}
                                            </Button>
                                          </Link>
                                        </td>
                                        <td>
                                          {/* <Link
                                            to="#"
                                            className="m-0"
                                            // onClick={() =>
                                            //   this.props.modelListOpen(po.id)
                                            // }
                                          > */}
                                          {po.items_count} Items
                                          {/* </Link> */}
                                        </td>
                                        <td>
                                          {moment(po.createdon).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </td>

                                        <td>{po.requestforquotation_code}</td>
                                        <td>
                                          {moment(
                                            po.requestforquotation_date
                                          ).format("DD-MM-YYYY")}
                                        </td>
                                        <td>{po.total}</td>

                                        <td>
                                          <Badge
                                            className="font-size-14"
                                            color={
                                              po.poauditstatus === 1
                                                ? "primary"
                                                : po.poauditstatus === 2
                                                ? "warning"
                                                : po.poauditstatus === 3
                                                ? "success"
                                                : "danger"
                                            }
                                          >
                                            {po.poauditstatus_name}
                                          </Badge>
                                        </td>
                                      </tr>
                                    ))}
                                  </>
                                ) : (
                                  <tr>
                                    <td colspan="7" className="text-center">
                                      <span className="font-size-18 text-danger">
                                        Data not available
                                      </span>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </SimpleBar>

                    {/* <Row className="p-1">
                      <Col md={12}>
                        <Card className="p-1">
                          <CardBody className="pt-1">
                            <div className="table-responsive m-1">
                              <TableScrollbar height="400px">
                                <Table className="mb-0 p-1 table-centered">
                                  <thead className="bg-light text-center">
                                    <tr>
                                      <th className="">S.No</th>
                                      <th className="">PO Code</th>
                                      <th className="">Submit Date</th>
                                      <th className="">View</th>
                                      <th className="">Audit</th>
                                     
                                    </tr>
                                  </thead>
                                  <tbody className="text-center">
                                    <tr>
                                      <td>01</td>
                                      <td>PO00001</td>
                                      <td>12/07/2021</td>
                                      <td>View</td>
                                      <td>Start</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </TableScrollbar>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row> */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { loading, params, AuditPOList, AuditPOListCount } =
    state.AuditReport;
  return {
    loading,
    AuditPOList,
    params,
    AuditPOListCount,
   
  };
};

export default connect(mapStatetoProps, {
  SetParams,
  AuditPO,
  getAuditPurchaseOrderList,
  AuditPurchaseOrderListSuccessful,
  OpenScreen,
})(AuditReports);
